import { TableCell, withStyles } from '@material-ui/core';

export const StyledTableCell = withStyles((theme) => ({
    head: {
        backgroundColor: '#1e293b',
        color: theme.palette.common.white,
        padding: '6px 12px',
        borderBottom: '1px solid #334155'
    },
    body: {
        fontSize: 13,
        padding: '0px 3px 8px 3px',
        border: 'none',
        verticalAlign: 'baseline'
    }
}))(TableCell);

export const HeadingTableCell = withStyles((theme) => ({
    head: {
        padding: '0px 3px',
        border: 'none'
    },
    body: {
        padding: '0px 3px 6px 3px',
        border: 'none',
        verticalAlign: 'baseline'
    }
}))(TableCell);

